import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = ({ settings }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{settings?.site_name || 'NieHairLabel'}</h3>
            <p>{settings?.site_description || 'Premium Quality Wigs'}</p>
            {settings?.facebook_url && (
              <div className="social-links">
                {settings?.facebook_url && (
                  <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer">Facebook</a>
                )}
                {settings?.instagram_url && (
                  <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer">Instagram</a>
                )}
                {settings?.twitter_url && (
                  <a href={settings.twitter_url} target="_blank" rel="noopener noreferrer">Twitter</a>
                )}
              </div>
            )}
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/track-order">Track Order</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            {settings?.contact_email && <p>Email: {settings.contact_email}</p>}
            {settings?.contact_phone && <p>Phone: {settings.contact_phone}</p>}
            {settings?.contact_address && <p>{settings.contact_address}</p>}
          </div>
        </div>

        <div className="footer-bottom">
          <p>{settings?.footer_text || `© ${currentYear} NieHairLabel. All rights reserved.`}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

